import React from "react"
import { useAppDispatch, useAppSelector } from "../../state/hooks"
import { setCartOpen } from "../../state/menus"
import { StaticImage } from "gatsby-plugin-image"

export const CartButton: React.FC = () => {
  const dispatch = useAppDispatch()

  const checkout = useAppSelector(state => state.checkout)
  const items = checkout?.lineItems?.edges || []
  const itemCount = items.reduce((pre, curr) => pre + curr.node?.quantity || 0, 0)

  return (
    <>
      <button className="cart-button flex items-center" onClick={() => dispatch(setCartOpen(true))}>
        <StaticImage
          className="object-contain w-10 h-10 md:hidden"
          src="../../img/uf-icon-white.png"
          alt="uf icon white base"
        />

        <span className="hidden uppercase md:inline">Cart </span>
        <span>({itemCount.toString().padStart(2, "0").slice(-2)})</span>
      </button>
    </>
  )
}
